import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "token"]

  requestReactNativeToken() {
    window.ReactNativeWebView.postMessage("requestToken")
  }

  upsertReactNativeToken({ detail: { token } }) {
    this.setTokenAndSubmitForm(token)
  }

  setTokenAndSubmitForm(token) {
    this.tokenTarget.value = token
    this.formTarget.requestSubmit()
  }
}
